import React from 'react';
import api from '../Api';
import queryString from 'query-string';
import { connectToUser } from './User/containers/UserDataStore';

const UserPreferencesContext = React.createContext();

export const useUserPreferences = () =>
	React.useContext(UserPreferencesContext);

export const connectToUserPreferences = Component => {
	return props => {
		return (
			<UserPreferencesContext.Consumer>
				{userPreferences => {
					return (
						<Component
							{...props}
							userPreferences={userPreferences}
						/>
					);
				}}
			</UserPreferencesContext.Consumer>
		);
	};
};

class UserPreferences extends React.Component {
	state = {
		fonts: {
			accentFontColor: '#5e4770',
		},
		reviewCopyDownloadPreferences: {},
		userAttributes: {},
		isLoading: true,
	};

	render() {
		return (
			<UserPreferencesContext.Provider value={this.getDataStore()}>
				{this.props.children}
			</UserPreferencesContext.Provider>
		);
	}

	componentDidUpdate(prevprops) {
		if (
			prevprops.userDataStore.isLoading() !==
			this.props.userDataStore.isLoading()
		) {
			this.getUserPreferences();
		}
	}

	componentDidMount() {
		this.getUserPreferences();
	}

	getUserPreferences() {
		const { isAnonymous, isLoading } = this.props.userDataStore;
		if (isLoading()) return;
		if (!isAnonymous()) {
			this.fetchUserAttributes();
			this.fetchReviewCopyDownloadPreferences();
			this.fetchUserPreferences();
		}
	}

	getDataStore = (state = this.state) => {
		return {
			state,
			getFonts: () => this.state.fonts,
			getUserAttributes: () => this.state.userAttributes,
			getReviewCopyDownloadPreferences: () =>
				this.state.reviewCopyDownloadPreferences,
			saveKindlePreferences: (email, kindleDownloadMethod) => {
				return api
					.put(
						`/api/v1/me/preferences/reviewCopyDownload/kindle/${kindleDownloadMethod}`,
						email,
					)
					.then(() => this.fetchReviewCopyDownloadPreferences());
			},
			saveDrcDownloadFormatPreference: format => {
				return api
					.put(
						`/api/v1/me/preferences/reviewCopyDownload/preferredFormat/${format}`,
					)
					.then(() => this.fetchReviewCopyDownloadPreferences());
			},
			saveRoleSummary: async roleSummaryKey =>
				await this.saveRoleSummary(roleSummaryKey),
			saveRoleDescription: async roleDescription =>
				await this.saveRoleDescription(roleDescription),
			saveLinks: async (linksValuesById, appUserId) =>
				await this.saveLinks(linksValuesById, appUserId),
		};
	};

	fetchUserAttributes() {
		api.get('/api/v1/me/attributes').then(userAttributes =>
			this.setState({ userAttributes }),
		);
	}

	fetchReviewCopyDownloadPreferences() {
		api.get('/api/v1/me/preferences/reviewCopyDownload')
			.then(reviewCopyDownloadPreferences =>
				this.setState({ reviewCopyDownloadPreferences }),
			)
			.catch(e => console.error(e))
			.finally(
				this.setState({
					isLoading: false,
				}),
			);
	}

	fetchUserPreferences() {
		var userPreferenceDtosFilter = [
			{ type: 'fonts', name: 'accFontOption' },
		];
		api.post(
			'/api/v1/me/preferences?format=object',
			userPreferenceDtosFilter,
		).then(prefsResult => {
			if (typeof prefsResult !== 'undefined' && prefsResult !== null) {
				this.setState(prefsResult);
			}
		});
	}

	saveRoleSummary = async roleSummaryKey => {
		const urlBase = process.env.REACT_APP_EPLUS_REQUEST_URL;
		var values = {
			userRole: roleSummaryKey,
		};
		const stringifiedData = queryString.stringify(values);
		const url = `${urlBase}/GetJSONData.aspx?m=User&
			builder=saveUserRole&${stringifiedData}`;

		const response = await fetch(url, {
			method: 'GET',
			credentials: 'include',
		});
		const res = await response.json();

		let didSucceed = false;
		if (res.code === 'SUCCESS') {
			this.fetchReviewCopyDownloadPreferences();
			didSucceed = true;
		}
		return didSucceed;
	};

	saveRoleDescription = async roleDescription => {
		this.setState({ isLoading: true });
		const url = '/api/v1/me/galleys/requests/role';
		let didSucceed;
		try {
			await api.post(url, roleDescription);
			this.fetchReviewCopyDownloadPreferences();
			didSucceed = true;
		} catch (e) {
			console.error(e);
			didSucceed = false;
			this.setState({ isLoading: false });
		} finally {
			return didSucceed;
		}
	};

	saveLinks = async (linkValuesById, appUserId) => {
		const urlBase = process.env.REACT_APP_EPLUS_REQUEST_URL;
		const saveLinksData = {
			...linkValuesById,
			appUserId,
		};
		const stringifiedData = queryString.stringify(saveLinksData);
		const url = `${urlBase}/GetJSONData.aspx?m=User&
			builder=SaveUserProfileLinks&${stringifiedData}`;

		const response = await fetch(url, {
			method: 'GET',
			credentials: 'include',
		});
		const res = await response.json();

		let didSucceed = false;
		if (res.code === 'SUCCESS') {
			this.fetchUserAttributes();
			didSucceed = true;
		}
		return didSucceed;
	};
}

export default connectToUser(UserPreferences);
